import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "HERO_ACCESS",
  title: defineMessage({ id: "fig.access.HERO.title", defaultMessage: `Access` }),
  caption: defineMessage({
    id: "fig.access.HERO.caption",
    defaultMessage: `Globally, 88% of children complete primary school, 78% of adolescents complete lower secondary school and 59% of youth complete upper secondary school.`,
  }),
  source: defineMessage({
    id: "fig.access.HERO.source",
    defaultMessage: `GEM Report team analysis using household survey data`,
  }),
};
